import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import VouchersContent from "modules/Vouchers";
import React from "react";
import { setTitle } from "utilities/helper/setTitle";

const VouchersPage: React.FC = () => {
  setTitle("Digital Goods");
  return (
    <Auth>
      <Layout>
        <VouchersContent />
      </Layout>
    </Auth>
  );
};

export default VouchersPage;
